// src/controllers/atributoCotizaController.js

import { 
  getAtributoCotizas, 
  createAtributoCotiza, 
  updateAtributoCotiza, 
  deleteAtributoCotiza,
  getAtributoCotizasByCotizaCab,
  getAtributoCotizaById
} from '../models/atributoCotizaModel.js';
import Swal from 'sweetalert2';
import { toasts } from "svelte-toasts";
import pb from '../lib/pocketbase';

// Obtener lista de atributos de cotización paginados
export async function fetchAtributoCotizas(page, perPage) {
  try {
    const response = await getAtributoCotizas(page, perPage);
    return {
      atributo_cotiza: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching atributo_cotizas:", error);
    Swal.fire('Error', 'No se pudieron cargar los atributos de cotización', 'error');
    return null;
  }
}

// Obtener atributos de cotización por cotiza_cab
export async function fetchAtributoCotizasByCotizaCab(cotizaCabId, page = 1, perPage = 50) {
  try {
    const response = await getAtributoCotizasByCotizaCab(cotizaCabId, page, perPage);
    return {
      atributo_cotiza: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching atributo_cotizas by cotiza_cab:", error);
    return null;
  }
}

// Guardar o actualizar un atributo de cotización
export async function saveAtributoCotiza(atributoCotiza, currentAtributoCotizaId) {
  try {
    if (currentAtributoCotizaId) {
      await updateAtributoCotiza(currentAtributoCotizaId, atributoCotiza);
      toasts.add({
        title: 'Éxito',
        description: 'Atributo de cotización actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createAtributoCotiza(atributoCotiza);
      toasts.add({
        title: 'Éxito',
        description: 'Atributo de cotización creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving atributo_cotiza:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el atributo de cotización',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Eliminar un atributo de cotización
export async function removeAtributoCotiza(id) {
  try {
    await deleteAtributoCotiza(id);
    toasts.add({
      title: 'Éxito',
      description: 'Atributo de cotización eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting atributo_cotiza:", error);
    Swal.fire('Error', 'No se pudo eliminar el atributo de cotización', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'atributo_cotiza'
export function subscribeToAtributoCotizas(searchQuery, handleSearch) {
  pb.collection('atributo_cotiza').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromAtributoCotizas() {
  pb.collection('atributo_cotiza').unsubscribe('*');
}

// Buscar atributos de cotización con paginación
export async function searchAtributoCotizas(query, page = 1, perPage = 10) {
  const response = await pb.collection('atributo_cotiza').getList(page, perPage, {
    filter: `atributo.descrip ~ "${query}" || cotiza_cab.numero ~ "${query}"`,
    expand: 'atributo,cotiza_cab',
    sort: '-created'
  });
  return {
    atributo_cotiza: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}
